import React, { useEffect, useState, useRef } from "react";
import './Analytics.css'
import Select from 'react-select'
import axios from 'axios'
import DatePicker from 'react-datepicker'
import AnalyticsDownArrow from './../../../../images/analyticsdownarrow.png'
import FilterIcon from './../../../../images/filtericon.png'
import LineGraphIcon from './../../../../images/linegraphicon.png'
import LineGraphIconGrey from './../../../../images/linegraphicongrey.png'
import BarGraphIcon from './../../../../images/bargraphicon.png'
import BarGraphIconWhite from './../../../../images/bargraphiconwhite.png'
import DropDownIcon from './../../../../images/dropdownicon.png'
import UpStockArrow from './../../../../images/upstockarrow.png'
import DownStockArrow from './../../../../images/downstockarrow.png'
import NoAnalytics from './../../../../images/noanalytics.png'
import PaymentInfoBtn from './../../../../images/paymentinfobtn.png'
import calendericon from './../../../../images/calendericon.png'
import httpConfig from "../AxiosConfig/httpConfig";
import {axiosInstance} from "../AxiosConfig/AxiosInstance";
import Cookies from "universal-cookie";
import { Trans, useTranslation} from 'react-i18next'
import i18next from "i18next"
import {useNavigate} from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import styled from "styled-components"
import ArtistDots1 from './../../../../images/artistdots1.png'
import EArtistPage from './../../../../images/EartistPage.png'
import ArtistStepTarget from './../../../../images/artiststeptarget.png'

function EmptyAnalytics() {
    const [stepOption,setStepOption] = useState(0)
    const [dimensions, setDimensions] = useState({ 
        height: window.innerHeight,
        width: window.innerWidth
    })

    const handleResize = () => {
        setDimensions({
        width: window.innerWidth,
        height: window.innerHeight,
        });
    }

    useEffect(() => {
      window.addEventListener("resize", handleResize, false);
    }, []);
   

    return (
    <div style={{width:'100%',overflowX:'hidden',paddingTop:'3em'}}>
        {
            dimensions.width >= 1474 && <div style={{
                // backgroundColor:'red',
                backgroundColor:'#15171B',
                // backgroundImage:`url(${LaunchMusicBanner})`, 
                height:'75.18em',
                // height:'50px',
                width:'100%',
                backgroundSize:'cover',
                backgroundRepeat:'no-repeat',
                marginTop: '0em',
                padding: '0',
                display:'flex',
                flexDirection:'column',
                alignItems:'center',
                position:'relative',
                overflow:'hidden'
                // lineHeight:'0px',
                // margin:'0px',
                // padding:'0px',
                // flex:'1'
              }}>
            
              <div style={{width:'95%',display:'flex',flexDirection:'column',alignItems:'center',zIndex:'2'}}> 
              <div style={{display:'flex',flexDirection:'row',marginLeft:'3em'}}>
            
                <div style={{display:'flex',flexDirection:'column',alignItems:'flex-start'}}>
                  <div className='StepSlashes' style={{marginLeft:'-1.7em'}}>\\</div>
                  <span className='StepHeader' style={{marginLeft:'-1.5em'}}>Launch Your Music Journey<br/> in <span style={{color:'#9C4FFF'}}>Four Simple Steps</span></span>
                
                </div>
                {/* <img src={HowItWorksGraphic} style={{width:'19.03em',height:'1.124em',alignSelf:'flex-end',marginLeft:'6.5em'}}/> */}
                <div style={{width:'19.03em',height:'1.124em',alignSelf:'flex-end',marginLeft:'30.5em'}} className='Howitworkstxt'>
                  HOW IT WORKS
                </div>
              </div>

              <div style={{display:'flex',flexDirection:'row',marginTop:'4em',position:'relative'}}>
                
                <div style={{display:'flex',flexDirection:'column',marginRight:'1.5em'}}>

                  {
                    stepOption===0 &&
                    
                    <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>

                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>1.</span> &nbsp; &nbsp;Sign Up and Setup
                    </div>
                    <div className='SelectedStepDesc'>
                    Start by signing up for free. Set up your artist or producer profile to tailor your experience. Our dashboard is designed to give you full control with minimal fuss.
                    </div>
                    </div>
                    </div>
                  }
                  {
                    stepOption!==0 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(0)}>
                    1. &nbsp; &nbsp;Sign Up and Setup
                    </div>
                  }
                  {
                    stepOption===1 &&
                    <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                        <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                  
                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>2.</span> &nbsp; &nbsp;Upload and Distribute
                    </div>
                    <div className='SelectedStepDesc'>
                    Upload your tracks and select the platforms you want to reach. With just one click, your music is queued for distribution to over 150+ streaming services worldwide. Our system handles everything from formatting to compliance checks, ensuring your music is ready to make an impact.
                    </div>
                  </div>
                  </div>
                  }

                  {
                    stepOption!==1 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(1)}>
                    2. &nbsp; &nbsp;Upload and Distribute
                    </div>
                  }

                  {
                    stepOption===2 &&
                    <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>

                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>3.</span> &nbsp; &nbsp;Analyze and Earn
                    </div>
                    <div className='SelectedStepDesc'>
                    Once your music is live, monitor its performance through our real-time analytics dashboard. View streams, downloads, and earnings. Receive actionable insights to optimize your releases and maximize your revenue
                    </div>
                  </div>
                  </div>
                  }

                  {
                    stepOption!==2 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(2)}>
                    3. &nbsp; &nbsp;Analyze and Earn
                  </div>
                  }

                  {
                    stepOption===3 &&
                    <div  style={{overflow:'visible',width: '24.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{width: '24.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                  
                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>4.</span> &nbsp; &nbsp;Promote and Pitch
                    </div>
                    <div className='SelectedStepDesc'>
                    Utilize our suite of promotional tools to boost your presence. Get featured on playlists, use our social media promo kits, or submit your tracks for exclusive placement opportunities in films, commercials, and more.
                    </div>
                  </div>
                  </div>
                  } 

                {
                    stepOption!==3 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(3)}>
                  4. &nbsp; &nbsp;Promote and Pitch
                  </div>
                  }
                


                </div>
                {
                  stepOption ===0 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/reg7anpd5riyw6p8br2n"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(1)}/>
                }
                {
                  stepOption ===1 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/qd9cbsqkmaurkkbapend"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(2)}/>
                }
                {
                  stepOption ===2 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pjbqmausmdsobvrxnvxb"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(3)}/>
                }
                {
                  stepOption ===3 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uu4ogicvwcosyh1gub4e"} className="FadeImage" style={{width:'34.75em',height:'32em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(0)}/>
                }
              
                <div style={{display:'flex',flexDirection:'column'}}>
                {
                  stepOption ===0 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==0 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption ===1 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==1 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption ===2 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==2 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption ===3 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==3 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'1.5em',marginBottom:'1.41em'}}/>
                }
                  
                </div>
              </div>

              </div>
              </div>
       }

      {
            dimensions.width < 1474 && 
              <div style={{
                // backgroundColor:'red',
                backgroundColor:'#15171B',
                // backgroundImage:`url(${LaunchMusicBanner})`, 
                // height:'68.18em',
                // height:'50px',
                width:'100%',
                backgroundSize:'cover',
                backgroundRepeat:'no-repeat',
                marginTop: '0em',
                padding: '0',
                display:'flex',
                flexDirection:'column',
                alignItems:'center',
                position:'relative'
                // lineHeight:'0px',
                // margin:'0px',
                // padding:'0px',
                // flex:'1'
              }}>
               
              <div style={{width:'80%',display:'flex',flexDirection:'column',alignItems:'center',marginLeft:'-2em'}}> 
              

              <div style={{display:'flex',flexDirection:'row',marginTop:'18em',position:'relative'}}>
              <div style={{display:'flex',flexDirection:'row',alignItems:'center',justifyContent:'space-between',marginLeft:'0em',width:'90%',position:'absolute',top:'-18em',left:'2em'}}>
            
                <div style={{display:'flex',flexDirection:'column',width:'85%'}}>
                  <div className='StepSlashes' style={{marginLeft:'0em'}}>\\</div>
                  <span className='StepHeader' style={{marginLeft:'0em',width:'100%'}}>Launch Your Music Journey<br/> in <span style={{color:'#9C4FFF'}}>Four Simple Steps</span></span>
                
                </div>
                {/* <img src={HowItWorksGraphic} style={{width:'19.03em',height:'1.124em',alignSelf:'flex-end',marginLeft:'6.5em'}}/> */}
                <div style={{width:'20%',height:'1.124em',alignSelf:'flex-end'}} className='Howitworkstxt'>
                  HOW IT WORKS
                </div>
          </div>
                
                <div style={{display:'flex',flexDirection:'column',marginRight:'1.5em'}}>

                  {
                    stepOption===0 &&
                    
                    <div  style={{overflow:'visible',width: '15%',display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{marginRight:'0em',width: '20.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>

                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>1.</span> &nbsp; &nbsp;Sign Up and Setup
                    </div>
                    <div className='SelectedStepDesc'>
                    Start by signing up for free. Set up your artist or producer profile to tailor your experience. Our dashboard is designed to give you full control with minimal fuss.
                    </div>
                    </div>
                    </div>
                  }
                  {
                    stepOption!==0 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(0)}>
                    1. &nbsp; &nbsp;Sign Up and Setup
                    </div>
                  }
                  {
                    stepOption===1 &&
                    <div  style={{overflow:'visible',width: '18.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                        <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{marginRight:'0em',width: '20.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                  
                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>2.</span> &nbsp; &nbsp;Upload and Distribute
                    </div>
                    <div className='SelectedStepDesc'>
                    Upload your tracks and select the platforms you want to reach. With just one click, your music is queued for distribution to over 150+ streaming services worldwide. Our system handles everything from formatting to compliance checks, ensuring your music is ready to make an impact.
                    </div>
                  </div>
                  </div>
                  }

                  {
                    stepOption!==1 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(1)}>
                    2. &nbsp; &nbsp;Upload and Distribute
                    </div>
                  }

                  {
                    stepOption===2 &&
                    <div  style={{overflow:'visible',width: '18.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{marginRight:'0em',width: '20.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>

                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>3.</span> &nbsp; &nbsp;Analyze and Earn
                    </div>
                    <div className='SelectedStepDesc'>
                    Once your music is live, monitor its performance through our real-time analytics dashboard. View streams, downloads, and earnings. Receive actionable insights to optimize your releases and maximize your revenue
                    </div>
                  </div>
                  </div>
                  }

                  {
                    stepOption!==2 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(2)}>
                    3. &nbsp; &nbsp;Analyze and Earn
                  </div>
                  }

                  {
                    stepOption===3 &&
                    <div  style={{overflow:'visible',width: '18.875em',display:'flex',flexDirection:'column',position:'relative'}}>
                    <img src={ArtistStepTarget} className="TargetAnimation" style={{position:'absolute',marginLeft:'-1em',top:'45%'}}/>
                    <div className="StepOpenAnimation" style={{width: '20.875em',marginBottom:'1em',display:'flex',flexDirection:'column',position:'relative',backgroundColor:'rgba(199, 165, 255, 0.2)',padding:'1em 0em 0em 0.75em',borderImage:'linear-gradient(90deg, rgba(233,19,83,1) 0%, rgba(131,11,47,0) 100%)',borderWidth:'5px',borderStyle:'solid',borderImageSlice:'1',borderTopWidth:'0',borderLeftWidth:'0',borderRightWidth:'0'}}>
                  
                    <div className='SelectedStepTitle'>
                    <span style={{color:'#FF6694'}}>4.</span> &nbsp; &nbsp;Promote and Pitch
                    </div>
                    <div className='SelectedStepDesc'>
                    Utilize our suite of promotional tools to boost your presence. Get featured on playlists, use our social media promo kits, or submit your tracks for exclusive placement opportunities in films, commercials, and more.
                    </div>
                  </div>
                  </div>
                  } 

                {
                    stepOption!==3 &&
                    <div className='UnselectedStep' onClick={()=>setStepOption(3)}>
                  4. &nbsp; &nbsp;Promote and Pitch
                  </div>
                  }
                


                </div>
                {
                  stepOption ===0 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/reg7anpd5riyw6p8br2n"} className="FadeImage" style={{marginLeft:'-2.3em',aspectRatio:'1.08',height:'20.95em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(1)}/>
                }
                {
                  stepOption ===1 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/qd9cbsqkmaurkkbapend"} className="FadeImage" style={{marginLeft:'-2em',aspectRatio:'1.08',height:'20.95em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(2)}/>
                }
                {
                  stepOption ===2 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/pjbqmausmdsobvrxnvxb"} className="FadeImage" style={{marginLeft:'-2em',aspectRatio:'1.08',height:'20.95em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(3)}/>
                }
                {
                  stepOption ===3 &&
                  <img src={"https://res.cloudinary.com/ddvootytq/image/upload/f_auto,q_auto/uu4ogicvwcosyh1gub4e"} className="FadeImage" style={{marginLeft:'-2em',aspectRatio:'1.08',height:'20.95em',clipPath:'polygon(20% 0%, 80% 0%, 100% 0, 100% 80%, 100% 100%, 21% 100%, 0 79%, 0 0)',cursor:'pointer'}} onClick={()=>setStepOption(0)}/>
                }
              
                <div style={{display:'flex',flexDirection:'column'}}>
                {
                  stepOption ===0 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==0 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption ===1 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==1 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption ===2 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==2 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption ===3 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'#FF6694',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                {
                  stepOption !==3 &&
                  <div style={{width:'0.54em',height:'0.54em',backgroundColor:'rgba(255,255,255,0.2)',marginLeft:'0.5em',marginBottom:'1.41em'}}/>
                }
                  
                </div>
              </div>

              </div>
  
            </div>
       }
      </div>
      )
}

export default EmptyAnalytics;